import {ToggleControl} from '../../../components/Controls/ToggleControl';
import {EditedProject} from '../EditedProject';

export function ScalabilityControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <ToggleControl
            label="Scalable?"
            checked={project.Scalability}
            onChange={({checked}) =>
                setProjectAndValidate({
                    ...project,
                    Scalability: checked
                })
            }
        />
    );
}
